import { render, staticRenderFns } from "./QuotaRenewalBanner.vue?vue&type=template&id=28a19bd3&"
import script from "./QuotaRenewalBanner.vue?vue&type=script&lang=js&"
export * from "./QuotaRenewalBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports